import { type TFunction } from 'i18next';

type TFunc = TFunction<'translation', undefined>;

export const CancelShipmentsException = {
	ARCHIVED: 'ARCHIVED',
	GROUPS: 'GROUPS',
	NO_SHIPMENTS: 'NO_SHIPMENTS',
} as const;

export type CancelShipmentsException =
	(typeof CancelShipmentsException)[keyof typeof CancelShipmentsException];

export type CancelShipmentsExceptionMessage = {
	title: string;
	description: string;
};

export type CancelShipmentsExceptions = Record<
	CancelShipmentsException,
	CancelShipmentsExceptionMessage
>;

export const exceptions = (t: TFunc): CancelShipmentsExceptions => ({
	ARCHIVED: {
		title: t('general.invalid-action', 'Invalid action'),
		description: t(
			'pages.shipments_cancel.dialog.form.errors.deny_archived_shipments',
			'Archived shipments cannot be cancelled.',
		).toString(),
	},
	GROUPS: {
		title: t('general.invalid-action', 'Invalid action'),
		description: t(
			'pages.shipments_cancel.dialog.form.errors.deny_groups_shipments',
			'Please cancel shipments for individual groups below instead.',
		).toString(),
	},
	NO_SHIPMENTS: {
		title: t('general.invalid-action', 'Invalid action'),
		description: t(
			'pages.shipments_cancel.dialog.form.errors.deny_no_shipments',
			'No shipments selected. Nothing to cancel.',
		).toString(),
	},
});
